import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/pure-plank/banner-client.webp";

function Clientplank() {
  return (
    <section
      className="client_plank text_whitegreen back_black"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>The Client had?</h2>
            <p>
              The client had the idea based on which a digital platform was to
              be built. The raw idea had the potential to grab the market share
              but needed technical expertise to get it completed.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientplank;
